import React from "react";
import image from "../../images/stockCity.jpeg"
import { navigate, useStaticQuery, graphql, Link } from "gatsby";
import { getSrc } from "gatsby-plugin-image";

export default function CTA() {
  const data = useStaticQuery(graphql`
  query CTAQuery {
    allStrapiResortWebsites {
      edges {
        node {
          Rectangle5 {
            url
          }
        }
      }
    }
  }
  `)
  const company = data.allStrapiResortWebsites.edges[0].node
  console.log(company)
  return (
    <div className="-z-10">
      <section class="py-20 bg-blue-50">
        <div class="container mx-auto px-4">
          <div class="flex flex-wrap items-center justify-center">
            <div class="w-auto bg-white mb-10 lg:mb-0 lg:mr-8 py-8 px-10 rounded">
              <img class="h-16" src={company?.Rectangle5.url} alt="city skyline"/>
            </div>
            <div class="w-full lg:w-auto mb-10 lg:mb-0 text-center lg:text-left">
              <h2 class="max-w-xl mx-auto lg:mx-0 mb-2 text-4xl lg:text-5xl font-bold font-heading">So many ways to Help</h2>
              <p class="max-w-xl mx-auto lg:mx-0 text-gray-500 leading-loose">
                Not sure what you need? Give us a call and we can steer you in the right direction!! We are waiting to hear from you now.
              </p>
            </div>
            <div class="w-full lg:w-auto lg:ml-auto text-center"><a class="inline-block py-2 px-6 bg-blue-600 hover:bg-blue-700 text-white font-bold leading-loose rounded-l-xl rounded-t-xl transition duration-200" href="/contact">Contact Us</a></div>
          </div>
        </div>
      </section>
    </div>
  );
}
